import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
declare var $;

@Component({
  selector: 'app-catalogue-addorup',
  templateUrl: './catalogue-addorup.component.html',
  styleUrls: ['./catalogue-addorup.component.css']
})
export class CatalogueAddorupComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  //标头提示信息
  headerLoGo: string; 
  //数据绑定对象
  formModel: any = { };
  //所有可选目录信息
  treeDatas:any = [];
  // 禁止选择的父级
  readonlySelfIds:any = [];
  //提交按钮是否禁用
  clickEnable = true; 
  constructor(
    private jwt: SwJwtService,
    private instanceModuleService: InstanceModuleService,
    private box: SwMassageBoxService,  //消息提示框
    private kmsService: KmsService,   //请求服务
  ) { }

  ngOnInit() {
    //获取所有的目录数据
    this.getCatalogue();
  }

  clickLoca(upOrAdd: string, selectedData: any) {
    //修改操作
    if (upOrAdd == "Edit") {
      //修改提示头
      this.headerLoGo = "编辑资源云目录"
      // 查询资源云目录信息
      const id = this.param["selectedData"].catalogId;
      this.readonlySelfIds = [id];
      this.kmsService.queryRmsCatalogById(id).subscribe(
        res => {
          this.formModel = res.data;
        }
      )
    } else {
      this.headerLoGo = "新增资源云目录";
      this.readonlySelfIds = [];
    }
  }

  //获取所有的目录数据
  getCatalogue() {
    this.kmsService.queryAllCatalog().subscribe(
      data => {
        if (data.code == '200') {
          this.treeDatas = data.data;
          this.treeDatas.forEach(e => {
            e.id = e.catalogId;
            e.text = e.catalogName;
            e.pid = e.parentId;
          });
          //表单初始化
          this.clickLoca(this.param["upOrAdd"],this.param["selectedData"]);
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  //提交 保存 或者修改操作
  onSubmit({ value, valid }, event: Event) {
    if (valid) {
      this.clickEnable = false;
      const id = this.formModel.catalogId ? this.formModel.catalogId : this.instanceModuleService.uuid2();
      let params = {
        "catalogId": id,
        "catalogName": $.trim(this.formModel.catalogName),
        "parentId": this.formModel.parentId ? this.formModel.parentId : 'root',
        "catalogLevel": 0,
        "mapping": "",
        "sortNum": this.formModel.sortNum || this.formModel.sortNum === 0 ? this.formModel.sortNum : 999
      }
      if(this.param["upOrAdd"] == 'Add' && this.treeDatas.length == 0){
        const rootNode = this.treeDatas.find(e => e.parentId == 'root');
        // 默认以根节点作为父级
        params.parentId = rootNode.catalogId;
        params.mapping = rootNode.catalogId + ',' + params.catalogId;
        params.catalogLevel = 2;
      }else{
        // 根据parentId获取mapping
        params.mapping = this.getMapping(params.catalogId, params.parentId);
        params.catalogLevel = params.mapping.split(',').length;
      }
      this.kmsService.queryOneRmsCatalog({
        "catalogId": params.catalogId,
        "catalogName": params.catalogName,
        "parentId": params.parentId
      }).subscribe(
        res => {
          if(res.code == 200){
            if(res.data){
              this.box.info('资源云目录名称已存在！');
              this.clickEnable = true;
            }else{
              let func = this.param["upOrAdd"] == 'Edit' ? this.kmsService.updateRmsCatalog(params) : this.kmsService.saveRmsCatalog(params);
              func.subscribe(
                res => {
                  if(res.code == 200){
                    this.box.success('操作成功！');
                    this.modal.toggle();
                    this.callback.emit(true);
                  }
                }
              )
            }
          }
        }
      )
    }
  }

  // 根据parentId获取mapping
  getMapping(id,pid){
    if(pid == 'root'){
      return id;
    }else{
      let item = this.treeDatas.filter(e => e.id == pid);
      return this.getMapping(pid+','+id, item[0].parentId);
    }
  }
}

